import { useForm } from "react-hook-form";
import CustomInput from "../../../../../components/CustomInput/CustomInput";
import { CompanyInfoFields } from "./companyInfo.types";
import regexList from "../../../../../utils/regexList";
import Modal from "../../../../../components/Modal/Modal";
import { useSelector } from "react-redux";
import { useRef } from "react";

const CompanyInfo: React.FC = () => {
  const filePickerRef = useRef(null);
  const { companyDetails } = useSelector((state: any) => state.auth);
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm<CompanyInfoFields>({
    defaultValues: {
      isEditing: false,
      isLoading: false,
    },
  });
  const fields = watch();

  const handleFileChange = async (e) => {
    try {
      const file = e.target.files[0];
      setValue("file", file, { shouldDirty: true });
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          //@ts-ignore
          setValue("image", reader.result, { shouldDirty: true });
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {
      console.error("Error during file upload or API calls:", error);
    }
  };

  return (
    <div className="flex flex-1 flex-col py-8">
      <div
        className={`grid grid-cols-2 gap-5 ${
          fields?.isEditing ? "opacity-100" : "opacity-60"
        }`}
      >
        {/* Form container */}
        <div className="flex flex-col gap-4">
          {/* @ts-ignore */}
          <CustomInput
            disabled={!fields?.isEditing}
            label="Company Name"
            name="name"
            placeholder={"ABC Company"}
            control={control}
            errors={errors}
          />
          {/* @ts-ignore */}
          <CustomInput
            disabled={!fields?.isEditing}
            label="Website URL"
            name="websiteUrl"
            placeholder={"Ex: doe"}
            control={control}
            errors={errors}
          />
          {/* @ts-ignore */}
          <CustomInput
            disabled={!fields?.isEditing}
            label="Primary Contact Number"
            name="primaryContactNumber"
            placeholder={"Ex: doe"}
            control={control}
            errors={errors}
          />
          {/* @ts-ignore */}
          <CustomInput
            disabled={!fields?.isEditing}
            label="Company email address"
            name="email"
            placeholder={"Ex: doe"}
            rules={{
              required: "This field is required.",
              pattern: {
                value: regexList.email,
                message: "Please enter a valid email.",
              },
            }}
            control={control}
            errors={errors}
          />
          <div className="flex flex-col gap-4 mt-2">
            <label className="font-semibold text-primary text-sm">
              Company address
            </label>
            {/* @ts-ignore */}
            <CustomInput
              disabled={!fields?.isEditing}
              label="Address"
              name="address1"
              placeholder={"Ex: Project Manager"}
              control={control}
              errors={errors}
            />
            {/* @ts-ignore */}
            <CustomInput
              disabled={!fields?.isEditing}
              label={"City"}
              name="city"
              placeholder={"Ex: United Kingdom"}
              control={control}
              errors={errors}
            />
            {/* @ts-ignore */}
            <CustomInput
              disabled={!fields?.isEditing}
              label={"Country"}
              name="country"
              placeholder={"Ex: United Kingdom"}
              control={control}
              errors={errors}
            />
            {/* @ts-ignore */}
            <CustomInput
              disabled={!fields?.isEditing}
              label={"Postal Code"}
              name="zipCode"
              placeholder={"Ex: United Kingdom"}
              control={control}
              errors={errors}
            />
          </div>
        </div>
        {/* Image container */}
        <div className="flex  flex-col flex-1 gap-6 px-14 pt-10">
          <div className="flex self-center rounded-full h-40 w-40 bg-white items-center justify-center border">
            {fields?.logo || companyDetails?.logo ? (
              <img
                src={fields?.logo || companyDetails?.logo}
                className="rounded-full h-40 w-40 object-fill"
              />
            ) : (
              <span className="font-montserrat font-extrabold text-5xl text-gray-200">
                LOGO
              </span>
            )}
          </div>
          <button
            disabled={!fields?.isEditing}
            type="button"
            onClick={() => filePickerRef?.current?.click()}
            className="flex  items-center border rounded-lg overflow-hidden pr-2"
          >
            <span className="text-sm text-[#6f6f6f] font-medium py-2.5 px-3 bg-[#E9EAF0]">
              PNG/JPG
            </span>
            <span className="text-xs flex font-medium px-3 text-ngray flex-1 text-left whitespace-nowrap">
              {fields?.file
                ? fields?.file?.name
                : companyDetails?.logo
                ? companyDetails?.logo
                : "Upload logo here"}
            </span>
          </button>
          <input
            ref={filePickerRef}
            type="file"
            className="hidden"
            accept=".png, .jpg"
            onChange={handleFileChange}
          />
        </div>
      </div>
      {/* Image Cropper Modal */}
      <Modal isOpen={!!fields?.image}>
        <div className="flex flex-col mt-7">
          {/* {fields?.image && (
              <Cropper
                src={fields?.image}
                ref={cropperRef}
                style={{ height: 400, width: "100%" }}
                aspectRatio={1}
                viewMode={2}
                guides={false}
                minCropBoxWidth={50} // Minimum width for the crop area
                minCropBoxHeight={50} // Minimum height for the crop area
              />
            )} */}
          <div className="mt-10 flex justify-end">
            <button
              // onClick={(e) => getCroppedImage(e)}
              className="bg-primary text-white px-6 py-2.5 rounded-md"
            >
              Crop Image
            </button>
          </div>
        </div>
        <style>
          {`
                /* Ensure the cropper's crop box is circular */
                .cropper-face,
                .cropper-view-box,
                .cropper-crop-box {
                    border-radius: 50% !important; /* Make crop area circular */
                    border: 2px solid white !important; /* Optional: Set the color of the circular crop lines */
                }

                .cropper-face {
                    background-color: rgba(0, 0, 0, 0.3) !important; /* Optional: Set the background color of the circular crop area */
                }

                .cropper-view-box {
                    border-radius: 50% !important; /* Make sure the selection area is circular */
                }

                .cropper-crop-box {
                    border-radius: 50% !important; /* Ensure the cropping boundary is circular */
                }
            `}
        </style>
      </Modal>
    </div>
  );
};

export default CompanyInfo;
